export const ONBOARDING_REQUEST = 'gustav/signUp/ONBOARDING_REQUEST';
export const ONBOARDING_ERROR = 'gustav/signUp/ONBOARDING_ERROR';
export const ONBOARDING_SUCCESS = 'gustav/signUp/ONBOARDING_SUCCESS';

export const INVITATION_DATA_REQUEST = 'gustav/signUp/INVITATION_DATA_REQUEST';
export const INVITATION_DATA_SUCCESS = 'gustav/signUp/INVITATION_DATA_SUCCESS';
export const INVITATION_DATA_ERROR = 'gustav/signUp/INVITATION_DATA_ERROR';
